import { CircularProgress, Dialog, DialogContent, DialogTitle, Divider, FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useProductChangeHistoryDetails } from 'v2/hooks/useProductChangeHistoryDetails';

import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import ChangesList from './ChangesList';
import { FieldsNameBR } from './constants';
import { useStyles } from './styles';
import { Title } from './Title';

import type { ChangeLogHistory } from './constants';

type ChangeHistoryDetailsProps = {
  data: ChangeHistoryContentItem;
  isOpen: boolean;
  onClose: () => void;
};

function ChangeHistoryDetails({ data, isOpen, onClose }: ChangeHistoryDetailsProps) {
  const classes = useStyles();
  const [filteredField, setFilteredField] = React.useState('0');

  const changeHistoryDetailsQuery = useProductChangeHistoryDetails({
    productId: data.productId,
    historyId: data.historyId,
  });

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilteredField(event.target.value as string);
  };

  const getFilterActionOptions = (changeLog: ChangeLogHistory[]) => {
    const fields = changeLog.map((history) => ({
      label: FieldsNameBR[history.field],
      value: history.field,
    }));

    const fieldOptions = fields.map((field) => (
      <MenuItem key={`field-${field.value}`} value={field.value}>
        {field.label}
      </MenuItem>
    ));

    const blankOption = (
      <MenuItem key='field-empty' value='0'>
        Busque por campo
      </MenuItem>
    );

    return [blankOption, ...fieldOptions];
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullScreen>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Title content={data} onClose={onClose} />
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2} justifyContent='center'>
          {changeHistoryDetailsQuery.isLoading && (
            <Grid item>
              <CircularProgress />
            </Grid>
          )}

          {changeHistoryDetailsQuery.data && (
            <>
              <Grid item xs={12}>
                <FormControl variant='outlined' className={classes.formControl} size='small'>
                  <Select labelId='filter-action-label' id='filter-select' value={filteredField} onChange={handleChange}>
                    {getFilterActionOptions(changeHistoryDetailsQuery.data)}
                  </Select>
                </FormControl>
              </Grid>

              <ChangesList changelog={changeHistoryDetailsQuery.data} filteredField={filteredField} />
            </>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default ChangeHistoryDetails;
